import {Box, Button, Card, CardContent, Typography} from "@mui/material";
import {Shell} from "../../common/shell/shell.page";
import {Error as ErrorIcon} from "@mui/icons-material";
import {useNavigate} from "react-router-dom";
import application from "../../core/application";

export const NotPermissionPage = () => {
  const [user] = application.user.useState();
  const navigate = useNavigate();

  const content = (
    <Card sx={{maxWidth: 480, mx: "auto", textAlign: "center"}}>
      <CardContent sx={{p: {xs: 3, sm: 4}}}>
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            bgcolor: "error.light",
            color: "error.dark",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <ErrorIcon sx={{fontSize: 36}} />
        </Box>
        <Typography variant="h6" gutterBottom sx={{fontWeight: 700}}>
          Acesso negado
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{mb: 3}}>
          Você não tem permissão para executar esta ação.
        </Typography>
        <Button variant="contained" onClick={() => navigate("/painel")}>
          Voltar ao início
        </Button>
      </CardContent>
    </Card>
  );

  if (!user) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 2,
          bgcolor: "background.default",
        }}
      >
        {content}
      </Box>
    );
  }

  return <Shell title="Acesso negado">{content}</Shell>;
};
